// Helpers for media.swancreate.com permalinks. The /f/<guid> endpoint supports
// ?w=<px> (server-side thumbnail) and ?download=1 (force download). These only
// apply to media permalinks; any other URL (e.g. an external CDN logo) is returned as-is.
const isMedia = (url) => typeof url === "string" && url.includes("media.swancreate.com/f/");
const join = (url, param) => url + (url.includes("?") ? "&" : "?") + param;

// One-time cache-bust. Earlier responses were served `Cache-Control: immutable`,
// so browsers that loaded photos before they were watermarked will keep showing
// the un-watermarked version for a year and never revalidate. Changing the URL
// (a new cache key) forces a fresh fetch. The server ignores this unknown param.
// The server no longer sends `immutable`, so future in-place edits propagate via
// ETag revalidation without needing to bump this again.
const CACHE_BUST = "v=wm1";

export function mediaThumb(url, w) {
  if (!isMedia(url) || !w) return url;
  return join(join(url, "w=" + w), CACHE_BUST);
}

export function mediaDownload(url) {
  if (!isMedia(url)) return url;
  return join(join(url, "download=1"), CACHE_BUST);
}

// Force a real "Save as…" download instead of opening the image inline.
// The media host is cross-origin, so the HTML `download` attribute is ignored
// by the browser — what actually forces the save is the server responding to
// `?download=1` with `Content-Disposition: attachment`. That attachment response
// downloads in place (the page never navigates away) and carries the original
// filename, so we just trigger an anchor click at the force-download permalink.
export function downloadImage(url, filename) {
  const a = document.createElement("a");
  a.href = mediaDownload(url);
  if (filename) a.download = filename; // ignored cross-origin, harmless
  document.body.appendChild(a);
  a.click();
  a.remove();
}
